import { useContext } from 'react';
import { AppContext } from '@/context/AppContext';

export default function ScanProgress() {
  const { isScanning, scanStatus } = useContext(AppContext);

  if (!isScanning || !scanStatus) return null;

  const { done = 0, total = 0, percent = 0 } = scanStatus;

  return (
    <div 
      className="fixed top-0 left-0 right-0 z-50 bg-[#0A0F1E] border-b border-[#1E2D45]"
      data-testid="scan-progress"
    >
      <div className="max-w-[1320px] mx-auto px-5 py-3">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-syne font-semibold text-[#E2E8F0]">
            Scanning keywords...
          </span>
          <span className="text-sm font-mono text-[#00C48C]">
            {done} of {total} ({percent}%)
          </span>
        </div>
        <div className="h-2 bg-[#1E2D45] rounded-full overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-[#00C48C] to-[#0070F3] rounded-full transition-all duration-300"
            style={{ width: `${percent}%` }}
          />
        </div>
      </div>
    </div>
  );
}
